import format from 'date-fns/format'
import getDay from 'date-fns/getDay'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import { dateFnsLocalizer } from 'react-big-calendar'

import { AgendaMessages } from './model'

const locales = {
  'pt-BR': require('date-fns/locale/pt-BR'),
}

export const dateFnsDefaultLocale = locales['pt-BR']

export default dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
})

export const defaultMessages: AgendaMessages = {
  disabledPastSlot: 'Não é possível agendar em horários passados.',
}
